export const myOrderEn = {
  "orders created": "orders created",
  "this week": "this week",
  "sites delivery": "sites delivery",
  "for this week": "for this week",
  "no delivery": "no delivery",

  "my order": "my order",
  "create order": "create new order",
  "date order create": "Creation date",
  order: "Order name",
  "order no": "Order number",
  site: "Site",
  "total weight": "Total weights (Ton)",
  "Order Status": "Order Status",
  "delivery date": "Delivery date",
  "next delivery": "next delivery",
  "add new": "add new",
  weight: "weight",

  "my sites": "my sites",
  "add new site": "add new site",
  "site name": "site name",
  address: "address",
  "site manager": "site manager",
  "site man": "site man",
  "contact on site": "contact on site",

  contact: "contact",
  "add new contact": "add new contact",
  contacts: "contacts",
  name: "name",

  "phone number": "phone number",
  "job title": "job title",
  "create new contact": "create new contact",
  "contact details": "Contact details",
  "required fields": "Required fields",
  "delete this contact": "Delete this contact",

  completed: "completed",

  "supplier orders title": "My Orders",
  "supplier customers title": "My Customers",
  "supplier order search": "Search by order number, name or customer...",
  "supplier customer search": "Search by name, business number or contact...",

  "customer filter all": "Customer: All",
  "project filter all": "Project: All",
  "sort delivery date": "Sort: Delivery date",
  "sort oldest first": "Delivery: Oldest first",
  "sort newest first": "Delivery: Newest first",
  "new supplier order": "New Order",

  "supplier created date": "Created date",
  "supplier order number": "Order number",
  "supplier order name": "Order name",
  "supplier customer": "Customer",
  "supplier status": "Status",
  "supplier site": "Site",
  "supplier total weight": "Total weight (ton)",
  "supplier delivery date": "Delivery date",
  "open supplier order": "Open order",
  "no supplier orders": "No orders found",

  "update order status": "Update order status",
  "supplier status NEW": "New order",
  "supplier status QUOTE": "Quote",
  "supplier status IN_PRODUCTION": "In production",
  "supplier status SENT": "Sent",

  "customer status all": "Status: All",
  "activity filter all": "Sort: Active orders",
  "activity filter active": "With active orders",
  "activity filter none": "Without active orders",
  "add supplier customer": "Add Customer",

  "supplier customer name": "Customer name",
  "supplier business number": "Business No.",
  "supplier contact person": "Contact person",
  "supplier phone": "Phone",
  "supplier active orders": "Active orders",
  "supplier customer status": "Status",
  "supplier actions": "Actions",
  "active orders count": "active",

  "customer status ACTIVE": "Active",
  "customer status NEW": "New",
  "customer status INACTIVE": "Inactive",

  "supplier email action": "Email",
  "no supplier customers": "No customers found",

  "add customer modal title": "Add New Customer",
  "add customer modal subtitle": "Fill in the customer details",
  "supplier customer name placeholder": "Company name",
  "supplier business number placeholder": "Identification number",
  "supplier contact placeholder": "Contact person name",
  "supplier email": "Email",
  "supplier address": "Address / Site",
  "supplier address placeholder": "Street, city",
  "supplier cancel": "Cancel",
  "supplier add customer submit": "Add Customer",

  "active orders modal title": "Active Orders · {{customer}}",
  "active orders modal count": "active orders",
  "supplier order": "Order",
  "supplier ton": "ton",
  "no active customer orders": "No active orders",
  "view all customer orders": "View all customer orders",

  "view customer details": "Customer details",
  "edit customer": "Edit customer",
  "delete customer": "Delete customer",
  "delete customer confirm": "Delete this customer?",
  "edit customer details": "Edit details",

  "customer active orders statistic": "Active orders",
  "customer total orders statistic": "Total orders",
  "customer total tons statistic": "Total tons",

  "customer contacts title": "Contacts",
  "add customer contact": "Add contact",
  "contact name": "Name",
  "contact role": "Role",
  "delete contact confirm": "Delete this contact?",
  "supplier save": "Save",

  "customer orders title": "Orders",
  "showing customer orders": "Showing {{shown}} of {{total}}",
  "edit customer modal title": "Edit Customer",
  "edit customer modal subtitle": "Update the customer details",
  "supplier update customer submit": "Save Changes",

  "copy order number": "Copy order number",
  "order number copied": "Order number copied",
  "change order status": "Change order status",
  "open order details": "Open order details",
  "show active orders": "Show active orders",
  "send customer email": "Send customer email",
  "open customer actions": "Open customer actions",
  "close window": "Close window",
  "expand details": "Show details",
  "collapse details": "Hide details",
  "select customer": "Select customer",
  "update order status": "Update order status",
  "no filter results": "No results found",
  "order actions": "Order actions",
  "incoming order edit warning":
  "Please note: you are about to edit a customer's order. We recommend informing the customer about the changes.",
  "order edited by supplier":
  "This order was edited by the supplier",
  "incoming order edit warning title": "Edit customer order",
"cancel edit": "Cancel",
"continue to edit": "Continue editing",
};
